export default {
  getHead: () => {
    return [{name: '사업장명'}, {name: '부서'}, {name: '작성자'}, {name: '작성일'}, {name: '재해구분'}, {name: '첨부파일'}]
  } ,
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: return func.getContent(value).inputA_1
        case 1: return func.getContent(value).inputA_2
        case 2: return func.getContent(value).inputA_3
        case 3: return func.getCreatedDate(value.created_at) // 작성일
        case 4: return func.getContent(value).inputA_5
        case 5: return {
          type: 'file',
          files: func.getContent(value).fileList
        }
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.inputA_4) {
      nav.dateTarget = 'content$body.inputA_4'
      nav.dateBegin = 'nav.value.inputA_4.sDate'
      nav.dateEnd = 'nav.value.inputA_4.eDate'
    }
    return { inputA_4: nav.value.inputA_4, inputA_5: nav.value.inputA_5}
  },
  getSearchKeyword: (nav) => {
    return ['content$body.inputA_5*[:nav.page.p57.inputA_5]']
  },
}
